import { AgentModuleConfiguration } from "@/models";
import * as utilities from "@/services/Utilities";

export type ColumnDefinition = {
  fieldName: string;
  fieldLabel: string;
};

const DEFAULT_COLUMNS = {
  agentCompanyAgentsRelated: [],
  agencyAgentsRelated: [],
};

export class CompetitorReportColumnsService {
  public static columnsFromConfig(config: AgentModuleConfiguration | null): {
    agentCompanyAgentsRelated: ColumnDefinition[];
    agencyAgentsRelated: ColumnDefinition[];
  } {
    if (!config) return DEFAULT_COLUMNS;

    const agentCompanyAgentsColumns: ColumnDefinition[] = [];
    const agencyAgentsColumns: ColumnDefinition[] = [];

    for (const kind of config.agentCompanyAgentTypes) {
      const key = utilities.snakeCaseToCamelCase(kind);

      agentCompanyAgentsColumns.push({
        fieldName: `agent_company_agent_${kind}_nome`,
        fieldLabel: `${
          config.agentCompanyAgentConf[key]?.label ?? ""
        }`.toLocaleUpperCase(),
      });
      for (
        let i = 1;
        i <= (config.agentCompanyAgentConf[key]?.area?.depth ?? 0);
        i++
      ) {
        agentCompanyAgentsColumns.push({
          fieldName: `agent_company_agent_area_${kind}_depth${i}_nome`,
          fieldLabel: `${
            config.agentCompanyAgentConf[key].area?.labels?.find(
              (e: any) => e.depth == i
            )?.label ?? ""
          }`.toLocaleUpperCase(),
        });
      }
      for (
        let i = 1;
        i <= config.agentCompanyAgentConf[key].coordinator.depth;
        i++
      ) {
        agentCompanyAgentsColumns.push({
          fieldName: `agent_company_agent_coordinator_${kind}_depth${i}_nome`,
          fieldLabel: `${
            config.agentCompanyAgentConf[key].coordinator?.labels?.find(
              (e: any) => e.depth == i
            )?.label ?? ""
          }`.toLocaleUpperCase(),
        });
      }
    }

    for (let i = 1; i <= config.agencyAgentConf.area.depth; i++) {
      agencyAgentsColumns.push({
        fieldName: `area_agency_agent_depth${i}_nome`,
        fieldLabel: `${
          config.agencyAgentConf?.area?.labels?.find((e: any) => e.depth == i)
            ?.label ?? ""
        }`.toLocaleUpperCase(),
      });
    }

    for (let i = 1; i <= config.agencyAgentConf.coordinator.depth; i++) {
      agencyAgentsColumns.push({
        fieldName: `coordinator_agency_agent_depth${i}_nome`,
        fieldLabel: `${
          config.agencyAgentConf?.coordinator?.labels?.find(
            (e: any) => e.depth == i
          )?.label ?? ""
        }`.toLocaleUpperCase(),
      });
    }

    return {
      agentCompanyAgentsRelated: agentCompanyAgentsColumns,
      agencyAgentsRelated: agencyAgentsColumns,
    };
  }
}
